import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import type { TutorialData } from '../types';
import TutorialCard from './TutorialCard';

interface TutorialCarouselProps {
  tutorials: TutorialData[];
  openModal: (key: string) => void;
  currentLang: string;
  t: (key: string, lang: string) => string;
}

const TutorialCarousel: React.FC<TutorialCarouselProps> = ({ 
  tutorials, 
  openModal, 
  currentLang, 
  t 
}) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: Math.min(4, tutorials.length),
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    centerMode: false,
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: Math.min(4, tutorials.length),
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          centerMode: false,
          centerPadding: '0'
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, tutorials.length),
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          centerMode: false,
          centerPadding: '0'
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(2, tutorials.length),
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0'
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0',
          arrows: false,
          dots: true,
          variableWidth: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '10px',
          arrows: false,
          dots: true,
          variableWidth: false
        }
      }
    ]
  };

  return (
    <div className="tutorial-carousel">
      <Slider {...settings}>
        {tutorials.map((tutorial) => (
          <div key={tutorial.key} className="tutorial-slide">
            <TutorialCard 
              data={tutorial}
              openModal={openModal}
              currentLang={currentLang}
              t={t}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TutorialCarousel;
